import type { CommerceHttpAdapter } from '../../client/CommerceHttpAdapter.js'
import type { CacheStrategy } from '../../workers/CacheStrategy.js'
import type { SessionInfo } from '../../types/index.js'

export class SessionModule {
  constructor(
    private readonly http: CommerceHttpAdapter,
    private readonly cache: CacheStrategy
  ) {}

  /** Récupère les informations de la session en cours */
  getSession(): Promise<SessionInfo> {
    return this.cache.execute(
      'session:raw',
      () => this.http.get<SessionInfo>('/commerce/api/sessions/raw'),
      'network-first'
    )
  }

  /** Associe un magasin à la session */
  async associateStore(storeGuid: string): Promise<SessionInfo> {
    const result = await this.http.post<SessionInfo>(
      `/commerce/api/sessions/associate/store/${storeGuid}`
    )
    await this.cache.execute('session:raw', () => Promise.resolve(result), 'network-first')
    return result
  }
}
